import script from "./OnboardingWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingWizard.vue?vue&type=style&index=0&id=6b9b2258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9b2258"]])

export default __exports__